import { _ as __decorate, a as __metadata } from '../tslib.es6-Cv888lzs.js';
import { ItCollapseBase } from '@italia/collapse';
import { css, html } from 'lit';
import { when } from 'lit/directives/when.js';
import { property, customElement } from 'lit/decorators.js';

var styles = css`@charset "UTF-8";
:host {
  display: block;
  font-family: var(--bsi-callout-font-family, inherit);
  font-size: var(--bsi-callout-font-size, 1rem);
}

/* Anti-FOUC: nascondi il contenuto finché il componente non è definito */
:host(:not(:defined)) {
  visibility: hidden;
}

:host([big-text]) {
  --bsi-callout-text-size: 18px;
}

.collapse-div {
  display: flex;
  flex-direction: column-reverse;
  border-bottom: none;
}

.collapse-wrapper {
  display: flex;
  flex-direction: column-reverse;
  align-items: stretch;
  gap: var(--it-spacing-xs, 0.75rem);
}

.collapse-header {
  display: flex;
  width: 100%;
  align-items: center;
  padding-top: var(--it-spacing-sm, 1rem);
  border-top: 1px solid var(--it-border-color, #e6e9f2);
  margin-top: 0;
  gap: var(--it-spacing-sm, 1rem);
}

.collapse-content {
  width: 100%;
}

.collapse-body {
  padding: 0;
  color: inherit;
  font-family: inherit;
  font-size: inherit;
}

.collapse-body ::slotted(p:last-child) {
  margin-bottom: var(--it-spacing-sm, 1rem);
}

.callout-more-toggle {
  display: inline-flex;
  width: auto;
  align-items: center;
  padding: 0;
  border: none;
  background-color: transparent;
  color: var(--bsi-primary, #0066cc);
  cursor: pointer;
  font: inherit;
  font-weight: 400;
  gap: var(--it-spacing-xxs, 0.5rem);
}

.callout-more-toggle:hover,
.callout-more-toggle:active {
  background: none;
  color: var(--bsi-primary-hover, var(--bsi-primary, #0066cc));
}

.callout-more-toggle span {
  position: relative;
  display: inline-block;
  width: 15px;
  height: 15px;
  box-sizing: border-box;
  border: 1px solid currentColor;
  border-radius: 50%;
  margin-top: 0.111rem;
  margin-left: 0.444rem;
}

.callout-more-toggle span::before,
.callout-more-toggle span::after {
  position: absolute;
  background: currentColor;
  content: "";
}

.callout-more-toggle span::before {
  top: 6px;
  left: 2px;
  width: 9px;
  height: 1px;
}

.callout-more-toggle span::after {
  top: 0;
  left: 6px;
  width: 1px;
  height: 9px;
  transform: translateY(2px);
  transition: transform 0.2s ease;
}

.callout-more-toggle[aria-expanded=true] span::after {
  transform: translateY(2px) rotate(90deg);
}

.callout-more-toggle:focus-visible {
  border-color: var(--bsi-focus-outline-color) !important;
  box-shadow: 0 0 0 2px var(--bsi-color-border-inverse), 0 0 0 5px var(--bsi-color-outline-focus) !important;
  outline: 3px solid transparent !important;
  outline-offset: 3px !important;
}

.collapse-header ::slotted(*) {
  display: inline-flex;
  align-items: center;
  margin-left: auto;
  color: var(--bsi-primary, #0066cc);
  font-weight: 400;
  gap: var(--it-spacing-xxs, 0.5rem);
  text-decoration: none;
}

.collapse-header ::slotted(.callout-more-download) {
  font-weight: 400;
}

.collapse-header ::slotted(*) svg {
  fill: currentColor;
}`;

let ItCalloutMoreCollapse = class ItCalloutMoreCollapse extends ItCollapseBase {
    constructor() {
        super(...arguments);
        this.bigText = false;
    }
    renderDefaultTrigger() {
        return html `<button
      type="button"
      class="callout-more-toggle"
      aria-expanded="${this.expanded}"
      aria-controls="${this._contentId}"
      id="${this._triggerId}"
      @click=${this.handleTriggerAction}
      @keyup=${this.handleTriggerAction}
      part="focusable trigger"
    >
      <slot name="label"></slot>
      <span aria-hidden="true"></span>
    </button>`;
    }
    render() {
        const hasCustomTrigger = !!this.triggerElement;
        const classPrefix = this.isAccordion ? 'accordion-' : 'collapse-';
        return html `
      <div class="collapse-div" part="collapse-div">
        <div class="${classPrefix}item" part="${classPrefix}item">
          <div class="collapse-wrapper">
            <div class="collapse-header">
              ${when(!hasCustomTrigger, () => this.renderDefaultTrigger())}
              <slot name="trigger" @slotchange=${this.handleTriggerSlotChange} part="trigger"></slot>
              <slot name="extra" part="extra"></slot>
            </div>
            <div
              class="collapse-content"
              part="content"
              role="region"
              aria-labelledby="${this._triggerId}"
              id="${this._contentId}"
            >
              <div class="${classPrefix}body">
                <slot name="content"></slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;
    }
};
ItCalloutMoreCollapse.styles = [ItCollapseBase.styles, styles];
__decorate([
    property({ type: Boolean, attribute: 'big-text', reflect: true }),
    __metadata("design:type", Object)
], ItCalloutMoreCollapse.prototype, "bigText", void 0);
ItCalloutMoreCollapse = __decorate([
    customElement('it-callout-more-collapse')
], ItCalloutMoreCollapse);

export { ItCalloutMoreCollapse };
//# sourceMappingURL=it-callout-more-collapse.js.map
